"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createRole = createRole;
exports.deleteRole = deleteRole;
exports.getRoleById = getRoleById;
exports.getRoleResTree = getRoleResTree;
exports.queryRolePage = queryRolePage;
exports.saveRoleDataAuth = saveRoleDataAuth;
exports.saveRoleRes = saveRoleRes;
exports.updateRole = updateRole;
var _requestAuth = _interopRequireDefault(require("@/utils/requestAuth"));
// 获取角色列表
function queryRolePage(query) {
  return (0, _requestAuth.default)({
    url: '/sysRole/page',
    method: 'get',
    params: query
  });
}

// 创建角色
function createRole(data) {
  return (0, _requestAuth.default)({
    url: '/sysRole',
    method: 'post',
    data: data
  });
}

// 更新角色
function updateRole(data) {
  return (0, _requestAuth.default)({
    url: '/sysRole',
    method: 'put',
    data: data
  });
}

// 获取角色详情
function getRoleById(id) {
  return (0, _requestAuth.default)({
    url: '/sysRole/' + id,
    method: 'get'
  });
}

// 获取角色树和该角色对应的资源
function getRoleResTree(query) {
  return (0, _requestAuth.default)({
    url: '/sysRoleRes/list',
    method: 'get',
    params: query
  });
}

// 删除角色信息
function deleteRole(id) {
  return (0, _requestAuth.default)({
    url: '/sysRole/' + id,
    method: 'delete'
  });
}

// 保存角色资源关系
function saveRoleRes(data) {
  return (0, _requestAuth.default)({
    url: '/sysRoleRes',
    method: 'post',
    data: data
  });
}

// 保存角色的数据权限
function saveRoleDataAuth(data) {
  return (0, _requestAuth.default)({
    url: '/sysRoleSensitiveAuth/update',
    method: 'put',
    data: data
  });
}